const ZIP_CODE_REGEX = /^\d{5}$/;

/**
 * Validates a German zip code (5 digits).
 * Returns `true` if valid, or an error message string otherwise.
 */
export function isValidZipCode(zipCode: string): true | string {
  return (
    ZIP_CODE_REGEX.test(zipCode) ||
    "Bitte geben Sie eine gültige Postleitzahl ein."
  );
}
